import {
  toWSDateString,
  WSCard,
  WSGrid,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { WorkLogStatus } from "@wingspanhq/payments/dist/interfaces";
import { useHistory } from "react-router-dom";
import { getNextPayrollCutOffDate } from "../../../Invoices/utils/payables";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayrollSettings } from "../../../query/payments/queries";
import { useQueryWorkLogsSummary } from "../../../query/workLog/queries/useQueryWorkLogsSummary";
import { PATH_WORK_LOGS_PAYER_TAB_TO_APPROVE } from "../paths";
import { WidgetWorkLogsPayerView } from "./WidgetWorkLogsPayerView";

export const WorklogsPayerDashboard: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();

  // Query for "To approve" count
  const queryToApproveCount = useQueryWorkLogsSummary({
    "filter[payerId]": userId,
    "filter[status][=]": WorkLogStatus.Approved
  });

  const toApproveCount = queryToApproveCount.data?.listSize ?? 0;

  // Query for payroll settings to get next payroll date
  const queryPayrollSettings = useQueryPayrollSettings(userId, {
    retry: false
  });
  const nextPayrollDate = queryPayrollSettings.data
    ? toWSDateString(
        getNextPayrollCutOffDate(queryPayrollSettings.data),
        "monthDate"
      )
    : "--";

  return (
    <WSGrid gutter="2XL" mt="XL">
      <WSGrid.Item span={{ m: "8" }}>
        <WSList gap="M">
          {/* To approve card */}
          <WSCard
            divider="bottom"
            header={{
              label: {
                avatar: {
                  type: "icon",
                  icon: "alert",
                  size: "M",
                  colorBackground: "amber50",
                  color: "amber400"
                },
                text: "To approve:"
              }
            }}
            actions={{
              alignment: "left",
              buttons: [
                {
                  kind: "Link",
                  label: "Review and approve",
                  rightIcon: "chevron-right",
                  size: "S",
                  onClick: () =>
                    history.push(PATH_WORK_LOGS_PAYER_TAB_TO_APPROVE)
                }
              ]
            }}
          >
            <WSText.ParagraphSm color="gray500">
              {toApproveCount} work logs awaiting your review
            </WSText.ParagraphSm>
          </WSCard>

          {/* Contractor changes in progress card */}
          <WSCard
            divider="bottom"
            header={{
              label: {
                avatar: {
                  type: "icon",
                  icon: "time",
                  size: "M",
                  colorBackground: "gray100",
                  color: "gray500"
                },
                text: "Contractor changes in progress"
              }
            }}
            actions={{
              alignment: "left",
              buttons: [
                {
                  kind: "Link",
                  label: "View",
                  rightIcon: "chevron-right",
                  size: "S",
                  onClick: () =>
                    history.push(PATH_WORK_LOGS_PAYER_TAB_TO_APPROVE)
                }
              ]
            }}
          >
            <WSText.ParagraphSm color="gray500">
              0 work logs with contractor changes in progress
            </WSText.ParagraphSm>
          </WSCard>

          {/* Next payroll card */}
          <WSCard
            divider="bottom"
            header={{
              label: {
                avatar: {
                  type: "icon",
                  icon: "calendar",
                  size: "M",
                  colorBackground: "blue50",
                  color: "blue500"
                },
                text: `Next payroll: ${nextPayrollDate}`
              }
            }}
            actions={{
              alignment: "left",
              buttons: [
                {
                  kind: "Link",
                  label: "View in payables",
                  rightIcon: "chevron-right",
                  size: "S",
                  onClick: () => history.push("/member/invoices/payables")
                }
              ]
            }}
          >
            <WSText.ParagraphSm color="gray500">
              This is your next scheduled payment cycle
            </WSText.ParagraphSm>
          </WSCard>
        </WSList>
      </WSGrid.Item>

      <WSGrid.Item span={{ m: "4" }}>
        <WidgetWorkLogsPayerView
          title="Recent work logs"
          showEngagementDetails
          hideViewAll
        />
      </WSGrid.Item>
    </WSGrid>
  );
};
